import { WindowTitle } from "@saleor/components/WindowTitle";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import ProductCategoriesBiListComponent from "./views/ProductCategoriesBiList";
const ProductCategoriesBiList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <ProductCategoriesBiListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Product Details",
          description: "product details report section name"
        })}
      />

      <Routes>
        <Route path={""} element={<ProductCategoriesBiList />} />
      </Routes>
    </>
  );
};

export default Component;
